module.exports = __webpack_public_path__ + "card3.jpg?2877da9e6c620dafca034ddc27c19c91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/card3.jpg
// module id = 126
// module chunks = 0